__turbopack_context__.v({
  "container": "DashboardComponentHeader-module__NkQhOa__container",
  "header": "DashboardComponentHeader-module__NkQhOa__header",
  "separator": "DashboardComponentHeader-module__NkQhOa__separator",
  "separatorDaymadeGrey1": "DashboardComponentHeader-module__NkQhOa__separatorDaymadeGrey1",
  "separatorDefault": "DashboardComponentHeader-module__NkQhOa__separatorDefault",
  "titleContainer": "DashboardComponentHeader-module__NkQhOa__titleContainer",
});
